import React from 'react';
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";
import { Typography, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { isDarkTheme } from "../../helpers/darkTint";
import { Room } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
	locationContainer: {
		minWidth: "250px",
		maxWidth: "350px",
		borderRadius: "8px",
		overflow: "hidden",
		backgroundColor: theme.palette.background.paper,
		cursor: "pointer",
		border: `1px solid ${theme.palette.divider}`,
		"&:hover": {
			backgroundColor: theme.palette.action.hover,
		},
	},
	mapImage: {
		width: "100%",
		height: "200px",
		objectFit: "cover",
		display: "block",
		backgroundColor: isDarkTheme(theme) ? theme.palette.action.hover : "#e0e0e0",
	},
	locationInfo: {
		padding: "12px",
		display: "flex",
		alignItems: "flex-start",
		gap: "8px",
	},
	locationIcon: {
		color: theme.palette.error.main,
		fontSize: "24px",
		marginTop: "2px",
		flexShrink: 0,
	},
	textContainer: {
		flex: 1,
		minWidth: 0,
	},
	locationName: {
		fontSize: "14px",
		color: theme.palette.text.primary,
		fontWeight: 500,
		marginBottom: "4px",
		wordBreak: "break-word",
	},
	locationAddress: {
		fontSize: "13px",
		color: theme.palette.text.secondary,
		lineHeight: 1.4,
		wordBreak: "break-word",
	},
	viewMapText: {
		fontSize: "12px",
		color: theme.palette.primary.main,
		marginTop: "8px",
		display: "flex",
		alignItems: "center",
		gap: "4px",
	},
	noImageContainer: {
		padding: "16px",
	},
}));

const LocationPreview = ({ image, link, description }) => {
	const classes = useStyles();

	const handleLocation = () => {
		try {
			if (link) {
				window.open(link, '_blank');
			}
		} catch (err) {
			toastError(err);
		}
	};

	// Verifica se é um placeholder (sem imagem real)
	const hasImage = image && image !== 'LOCATION_PLACEHOLDER' && !image.includes('LOCATION_PLACEHOLDER');

	// Autor: GitHub Copilot | Data: 28/03/2026 | Motivo: ocultar exibicao de coordenadas puras na bolha de localizacao.
	const normalizedDescription = String(description || "").trim();
	const isCoordinateOnlyDescription = /^-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?$/.test(normalizedDescription);
	const displayDescription = isCoordinateOnlyDescription ? "" : normalizedDescription;

	// Parse da descrição para separar nome e endereço
	const locationLines = displayDescription ? displayDescription.split('\n').filter(line => line.trim()) : [];
	const locationName = locationLines[0] || '';
	const locationAddress = locationLines.slice(1).join(', ') || '';

	return (
		<Box className={classes.locationContainer} onClick={handleLocation}>
			{hasImage && (
				<img 
					src={image} 
					alt={i18n.t("messagePreview.location")}
					className={classes.mapImage}
					onError={(e) => {
						e.target.style.display = 'none';
					}}
				/>
			)}
			<Box className={hasImage ? classes.locationInfo : classes.noImageContainer}>
				<Room className={classes.locationIcon} />
				<Box className={classes.textContainer}>
					{locationName && (
						<Typography className={classes.locationName}>
							{locationName}
						</Typography>
					)}
					{locationAddress && (
						<Typography className={classes.locationAddress}>
							{locationAddress}
						</Typography>
					)}
					{!locationName && !locationAddress && displayDescription && (
						<Typography className={classes.locationAddress}>
							{displayDescription}
						</Typography>
					)}
					{!locationName && !locationAddress && !displayDescription && (
						<Typography className={classes.locationName}>
							{i18n.t("forwardMessageModal.previewSharedLocation")}
						</Typography>
					)}
					<Typography className={classes.viewMapText}>
						📍 {i18n.t("locationPreview.openInMaps")}
					</Typography>
				</Box>
			</Box>
		</Box>
	);
};

export default LocationPreview;